import { useEffect, useState } from 'react';
import { getUserPermissions } from 'asset-actions-lib/api/manageAccess';
export default function useFetchUserPermissions({
  objectType,
  objectId
}) {
  const [state, setState] = useState({
    loading: true,
    userIds: [],
    error: undefined
  });
  useEffect(() => {
    setState({
      loading: true,
      userIds: [],
      error: undefined
    });
    getUserPermissions({
      objectType,
      objectId
    }).then(userIds => setState({
      loading: false,
      userIds,
      error: undefined
    })).catch(error => setState({
      loading: false,
      userIds: [],
      error
    }));
  }, [objectId, objectType]);
  return state;
}